interface Filterable {
	[key: string]: any;
}

export function filterList<T extends Filterable>(list: T[], properties: (keyof T)[], searchTerm: string): T[] {
	return list?.filter(item => properties.some(property => item[property]?.toString()?.toLowerCase()?.includes(searchTerm.toLowerCase())));
}
